<div class="" *ngIf="!data?.showSolutionPapers; else solutionBlock">
    <mat-dialog-content class="account-box" style="overflow: hidden; scroll-behavior: unset;">
        <div class="text-center">
            <img src="assets/img/account-create-confirmed.svg" alt="">
        </div>

        <div class="accont-created" style="margin-bottom:14px;">
            <h4 style="font-weight: 600; font-size: 20px; color: #1E2A36;">{{ data?.message }}</h4>
        </div>

        <div class="accont-created-desc" style="margin-bottom:14px;">
            {{ data?.message2 }}
        </div>

        <div class="account-confirm-links text-center" style="margin-bottom:24px;">
            <a class="" (click)="accountSetup()">
                <!-- Personlize content in 4 quick steps  -->
                START ONBOARDING
            </a>
        </div>
        </mat-dialog-content>
    </div> 
        <ng-template #solutionBlock>
            <div class="ASM_vtr_papers_pop">
                <div class="assessment_mb-20 d-flex justify-content-center align-items-center header">
                    Choose a paper
                </div>
                <div *ngFor="let paper of data.papers; index as i">
                    <div (click)="paperClicked(paper)" class="ASM_paper_row align-items-center d-flex">
                       {{i+1}}. {{paper.rulename}}
                    </div>
                </div>
                
                <button class="btn-link assessment_mt-30 ASM_vtr_papers_pop_close" type="button" (click)="onClose()">CLOSE</button>
            </div>
        </ng-template>